// client/components/ui/zIndex.js
/**
 * Zentrale Z-Index-Scale für konsistente Layering
 * 
 * Verwendung:
 * import { Z_INDEX } from './zIndex';
 * style={{ zIndex: Z_INDEX.toast }}
 */

export const Z_INDEX = {
  // Toast-System (höchste Priorität)
  toast: 10000,
  
  // Modals & Sheets (über allem außer Toast)
  modal: 9000,
  sheet: 9000,
  
  // Popover & Dropdowns (müssen über Sheets liegen)
  popover: 9100,
  dropdown: 9100,
  selectPortal: 10160,
  
  // Sticky Headers & Navigation
  sticky: 100,
  nav: 100,
  
  // Standard Content
  base: 1,
};

export default Z_INDEX;
